import { DateFormat_get_yyyy$002DMM$002Ddd, DateModule_toStr, DateModule_ofDateTime } from "../../Svea.Dry/Time.js";
import { TerminateFeeDTO, TerminateFeeOptionJson } from "../Invoicee/Common.js";
import { parseInt$, strToOpt } from "../../Utils.js";
import { PeriodModule_toString } from "../../DomainTypes.js";
import { UpdateFeeDTO } from "../FeeModal/Model.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/List.js";

export function convertFeeToTerminateFeeDTO(terminateFeeDetails) {
    let d;
    return new TerminateFeeDTO((d = DateModule_ofDateTime(terminateFeeDetails.Date), DateModule_toStr(DateFormat_get_yyyy$002DMM$002Ddd(), d)), new TerminateFeeOptionJson(terminateFeeDetails.RemoveBoundMonths, terminateFeeDetails.RemoveCancellationPeriod));
}

export function getUpdateFeeDTOs(fee, vm) {
    let matchValue, s;
    return singleton(new UpdateFeeDTO(vm.AmountExclVat, vm.BoundMonths, vm.BoundToDate, vm.SelectedCancellationPeriod, (matchValue = vm.ChosenCancelledDate, (matchValue.tag === 2) ? vm.CancelledDate : ((matchValue.tag === 1) ? vm.CancelledDate : (void 0))), void 0, strToOpt(vm.Description), fee.FeeNumber, parseInt$(vm.SelectedTemplate), vm.SelectedMonthsInAdvance, vm.StartDate, vm.SelectedVatRatePercent, vm.SelectedAccountNo, vm.BilledTo, (s = PeriodModule_toString(vm.SelectedPeriod), s.toLocaleUpperCase()), vm.Units));
}

